'use client';

import { useCallback } from 'react';

/**
 * Navigates to /search for a text query. This needs a FULL navigation (never
 * router.push): the search page seeds `q` server-side, and during a soft
 * transition its SearchParameterManager can serialize engine state onto the
 * previous page's still-live URL — rewriting history to `<old-path>?q=…` and
 * silently clearing the query (same finding as POC commit 3864cbb3, see
 * specs/coveo-ssr/10-feature-ssr-header-search.md).
 */
export const useNavigateToSearch = () =>
  useCallback((query: string) => {
    window.location.assign(`/search?q=${encodeURIComponent(query)}`);
  }, []);
